/** Plain-language names for the platform's system roles (authorization-service seeds). */
const ROLE_LABELS: Record<string, { label: string; description: string }> = {
  owner: { label: 'Owner', description: 'Full control, including billing.' },
  admin: { label: 'Administrator', description: 'Manages everything except billing.' },
  billing: { label: 'Billing', description: 'Views and manages billing.' },
  tech: { label: 'Technical', description: 'Manages domains, DNS and hosting.' },
  mail_admin: { label: 'Mail administrator', description: 'Manages mailboxes, aliases and mail settings.' },
  read_only: { label: 'Read-only', description: 'Can view, but not change, settings.' },
  customer_admin: { label: 'Customer administrator', description: 'Manages this customer account.' },
  customer_user: { label: 'Customer user', description: 'Uses this customer account.' },
  operator: { label: 'Platform operator', description: 'Operates the hosting platform.' },
};

export function roleLabel(roleKey: string): string {
  return ROLE_LABELS[roleKey]?.label ?? roleKey.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
}

export function roleDescription(roleKey: string): string | undefined {
  return ROLE_LABELS[roleKey]?.description;
}

export type StatusTone = 'success' | 'warning' | 'danger' | 'neutral';

export function memberStatus(status: string): { label: string; tone: StatusTone } {
  switch (status) {
    case 'active': return { label: 'Active', tone: 'success' };
    case 'invited': return { label: 'Invited', tone: 'warning' };
    case 'suspended': return { label: 'Suspended', tone: 'danger' };
    default: return { label: status.replace(/^\w/, (c) => c.toUpperCase()), tone: 'neutral' };
  }
}
